import { IAccountingSystemRepositoryResponse, ILookupRepository } from "@/core/repositories/lookup";

export class GetAccountingSystemUseCase {
  constructor(private readonly lookupRepository: ILookupRepository) {}

  async execute(): Promise<IAccountingSystemRepositoryResponse> {
    return this.lookupRepository.getAccountingSystems();
  }
}
